<template lang="pug">
    main#app
        router-view
</template>

<script>
export default {
    name: "template-app",
}
</script>

<style lang="stylus" scoped src="./App.styl"></style>